import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

//common
import enCommon from '@/assets/locales/en/common.json';
import jaCommon from '@/assets/locales/ja/common.json';
//carriers
import enCarriers from '@/assets/locales/en/carriers.json';
import jaCarriers from '@/assets/locales/ja/carriers.json';
//sortmenu
import enSortMenu from '@/assets/locales/en/sortMenu.json';
import jaSortMenu from '@/assets/locales/ja/sortMenu.json';
import { carriersEn } from '@/assets/locales/en/carriers';
import { carriersJa } from '@/assets/locales/ja/carriers';
//roles
import enRoles from '@/assets/locales/en/roles.json';
import jaRoles from '@/assets/locales/ja/roles.json';
//users
import enUsers from '@/assets/locales/en/users.json';
import jaUsers from '@/assets/locales/ja/users.json';
//transportation
import enTransportation from '@/assets/locales/en/transportation.json';
import jaTransportation from '@/assets/locales/ja/transportation.json';
//inspection
import enInspection from '@/assets/locales/en/inspection.json';
import jaInspection from '@/assets/locales/ja/inspection.json';
//shipping
import enShipping from '@/assets/locales/en/shipping.json';
import jaShipping from '@/assets/locales/ja/shipping.json';
//payments
import enPayments from '@/assets/locales/en/payments.json';
import jaPayments from '@/assets/locales/ja/payments.json';
//customers
import enCustomers from '@/assets/locales/en/customers.json';
import jaCustomers from '@/assets/locales/ja/customers.json';
//auction
import enAuction from '@/assets/locales/en/auction.json';
import jaAuction from '@/assets/locales/ja/auction.json';
//reports
import enReports from '@/assets/locales/en/reports.json';
import jaReports from '@/assets/locales/ja/reports.json';
//utilities
import enUtilities from '@/assets/locales/en/utilities.json';
import jaUtilities from '@/assets/locales/ja/utilities.json';
//settings
import enSettings from '@/assets/locales/en/settings.json';
import jaSettings from '@/assets/locales/ja/settings.json';
// masters
import enMasters from '@/assets/locales/en/masters.json';
import jaMasters from '@/assets/locales/ja/masters.json';
// tasks
import enTasks from '@/assets/locales/en/tasks.json';
import jaTasks from '@/assets/locales/ja/tasks.json';
// marketing
import enMarketing from '@/assets/locales/en/marketing.json';
import jaMarketing from '@/assets/locales/ja/marketing.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'ja'],
    fallbackLng: 'en',
    resources: {
      en: {
        translation: {
          fieldBetween: 'Enter {{min}}–{{max}} characters',
          fieldRqd: 'This field is required',
          fieldMax: 'Enter up to {{max}} characters',
          fieldMin: 'Enter at least {{min}} characters',
          invalidAlpha: 'Use letters only',
          invalidAlphaNumeric: 'Use letters and numbers only',
          invalidEmail: 'Enter a valid email address',
          invalidPhone: 'Enter a valid phone number',
          invalidLineId: 'Enter a valid Line ID',
          invalidAddress: 'Enter a valid address',
          invalidFileType: 'File types should be {{filetypes}} only.',
          maxSize: 'File should be below {{size}} MB',
        },
        common: enCommon,
        carriers: { ...enCarriers, ...carriersEn },
        sortMenu: enSortMenu,
        roles: enRoles,
        users: enUsers,
        transportation: enTransportation,
        inspection: enInspection,
        shipping: enShipping,
        payments: enPayments,
        auction: enAuction,
        customers: enCustomers,
        reports: enReports,
        utilities: enUtilities,
        settings: enSettings,
        masters: enMasters,
        tasks: enTasks,
        marketing: enMarketing,
      },
      ja: {
        translation: {
          fieldBetween: '{{min}}〜{{max}}文字で入力してください',
          fieldRqd: '必須項目です',
          fieldMax: '{{max}}文字以内で入力してください',
          fieldMin: '少なくとも{{min}}文字を入力してください',
          invalidAlpha: '文字のみを使用してください',
          invalidAlphaNumeric: '英数字のみを使用してください',
          invalidEmail: '有効なメールアドレスを入力してください',
          invalidPhone: '有効な電話番号を入力してください',
          invalidLineId: '有効なLINE IDを入力してください',
          invalidAddress: '有効な住所を入力してください',
        },
        common: jaCommon,
        carriers: { ...jaCarriers, ...carriersJa },
        sortMenu: jaSortMenu,
        roles: jaRoles,
        users: jaUsers,
        transportation: jaTransportation,
        inspection: jaInspection,
        shipping: jaShipping,
        payments: jaPayments,
        auction: jaAuction,
        customers: jaCustomers,
        reports: jaReports,
        utilities: jaUtilities,
        settings: jaSettings,
        masters: jaMasters,
        tasks: jaTasks,
        marketing: jaMarketing,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
